import { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { IconYaPay } from '../../icon/IconYaPay';
import { Flex } from '../../layout/Flex';
import { PersonalDiscountType } from '../../posts/types';
import { Typography } from '../../typography/Typography';

export interface PayByConditionCaptionProps {
    type: PersonalDiscountType;
}

export const PayByConditionCaption: FC<PayByConditionCaptionProps> = ({ type }) => {
    const t = useTranslation();

    if (type === 'yandex_pay') {
        return (
            <Flex direction="row" alignItems="center" spacing={0.25}>
                <Typography variant="caption">{t('Картой')}</Typography>
                <IconYaPay color="var(--color-primary)" size={14} />
                <Typography variant="caption">{t('Пэй')}</Typography>
            </Flex>
        );
    }

    switch (type) {
        case 'ozon_card':
            return <Typography variant="caption">{t('Картой Ozon')}</Typography>;
        case 'alfa_card':
            return <Typography variant="caption">{t('Картой Альфа')}</Typography>;
        case 'vtb_card':
            return <Typography variant="caption">{t('Картой ВТБ')}</Typography>;
        case 'wb_card':
            return <Typography variant="caption">{t('WB Кошельком')}</Typography>;
        default:
            return null;
    }
};
